import { TSchemaBuilder } from "@pages/ManualDocumentV2/core";
import * as Yup from "yup";
import {
  customerSchema,
  documentInfoSchema,
  itemsSchema,
  recurringSchema,
  taxesSchema,
  totalsSchema,
  uploadSchema,
  vendorSchema,
} from "../../../_shared/schemaHelpers";

export const verifactuRegularInvoiceSchema: TSchemaBuilder = (t) =>
  documentInfoSchema({
    t,
    documentClass: "Invoice",
    poErrorKey: "poNumber_is_required",
    poRequired: false,
    dueDateRequired: true,
    enforceDateOrder: true,
  })
    .concat(customerSchema(t))
    .concat(vendorSchema(t))
    .concat(itemsSchema(t))
    .concat(taxesSchema(t))
    .concat(totalsSchema(t))
    .concat(uploadSchema())
    .concat(recurringSchema()) as Yup.ObjectSchema<any>;
